import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  ListArgs,
  SubscribersList,
  SubscribersIn,
  Subscribers,
  topliApi,
} from '@/shared/api/topli/TopliApi'

export const subscribersQueryKey = 'subscribers'

export type SubscribersListParams = ListArgs & {
  user_id?: number
}

export const fetchSubscribers = async (
  params?: SubscribersListParams,
): Promise<SubscribersList> => {
  const response = await topliApi.subscribers.list(params ?? {})
  return response
}

export const useSubscribers = (params?: SubscribersListParams) =>
  useQuery({
    queryKey: [subscribersQueryKey, params],
    queryFn: () => fetchSubscribers(params),
    enabled: params !== undefined,
  })

export const updateSubscriber = async (
  itemId: number,
  data: SubscribersIn,
): Promise<Subscribers> => {
  const response = await topliApi.subscribers.update(itemId, data)
  return response
}

export const useUpdateSubscriber = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ itemId, data }: { itemId: number; data: SubscribersIn }) =>
      updateSubscriber(itemId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [subscribersQueryKey] })
    },
  })
}
